
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ginhxOPIH0dY6O9zIxr1UbKOfuMHEwh77ELWbDWjdl5sMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRbQN_rjNnUsxlPxNCXDhnX2ujI_QUj2S9xS5qxAU2bsMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6MLz4SPjFipQrlkk5S2f7DSH4WskB50YweAOHSN5UfAMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexGn3mW_45knYzS30N033c6ULBhwXjqUtfivj1HMaD3uEcIMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93NCO6dsY5fsA7CYwtT1kbtiUBNJWMMa2i7To6hyqROZ8Meta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexTjOPbN1zLitzjGvGxKTXskX3jrCi7w2wZWul_7e0vsgMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93MbJyTFH6aDRs9eGPnT7Uh_45hy_TmgIDDi0YL78R0m2EIMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexlG7Cokd2krggYdy9IVj4pXt2SK_uRB28ALC39LVklCkMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93hTQ4_45p4OA1ibLh30X9yAZ_v83Ij_457I058XHcnXaradwMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexNnTxUhQNTtvkPbWOM0AhEMizqnMMNLS5PVAmXBnEknAMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexm_DHJ4jgWlxQvgizCbYTVQSAZuqJIebZPaPjKTmZ_uQMeta } from "/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexTjOPbN1zLitzjGvGxKTXskX3jrCi7w2wZWul_7e0vsgMeta || {},
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexlG7Cokd2krggYdy9IVj4pXt2SK_uRB28ALC39LVklCkMeta || {},
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexNnTxUhQNTtvkPbWOM0AhEMizqnMMNLS5PVAmXBnEknAMeta || {},
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexm_DHJ4jgWlxQvgizCbYTVQSAZuqJIebZPaPjKTmZ_uQMeta || {},
    component: () => import("/codebuild/output/src350537077/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]